'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchFieldTypeSelector = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SearchFieldTypeSelector, _React$Component);

  function SearchFieldTypeSelector() {
    (0, _classCallCheck3.default)(this, SearchFieldTypeSelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchFieldTypeSelector.__proto__ || (0, _getPrototypeOf2.default)(SearchFieldTypeSelector)).call(this));

    _this.handleWindowClick = _this.handleWindowClick.bind(_this);

    _this.state = {
      open: false
    };
    return _this;
  }

  (0, _createClass3.default)(SearchFieldTypeSelector, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        window.removeEventListener('click', this.handleWindowClick);
      }
    }
  }, {
    key: 'handleWindowClick',
    value: function handleWindowClick(ev) {
      this.setState({
        open: false
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(ev) {
      this.setState({
        open: !this.state.open
      });

      if (this.state.open) {
        window.removeEventListener('click', this.handleWindowClick);
      } else {
        window.addEventListener('click', this.handleWindowClick);
      }

      ev.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var open = this.state.open;
      var _props = this.props,
          value = _props.value,
          options = _props.options;
      var query = this.context.router.location.query;


      var styles = require('./SearchFieldTypeSelector.scss');
      var name = (options.find(function (t) {
        return t.value == value;
      }) || options[0]).name;

      var optionsClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.TypeSelector__options, true), (0, _defineProperty3.default)(_classnames, styles['TypeSelector__options--open'], open), _classnames));

      var getTo = function getTo(to) {
        return query.search ? to + '?search=' + encodeURIComponent(query.search) : to;
      };

      return _react2.default.createElement(
        'div',
        { className: styles.TypeSelector, onClick: this.handleClick.bind(this) },
        _react2.default.createElement(
          'span',
          { className: styles.TypeSelector__value },
          name
        ),
        _react2.default.createElement(
          'div',
          { className: optionsClasses },
          _react2.default.createElement('span', { className: styles['TypeSelector__optionsAngle'] }),
          _react2.default.createElement(
            'ul',
            null,
            options.map(function (o) {
              return _react2.default.createElement(
                'li',
                { key: o.value },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: getTo(o.to), className: styles.TypeSelector__option },
                  o.name
                )
              );
            })
          )
        )
      );
    }
  }]);
  return SearchFieldTypeSelector;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object
}, _class.propTypes = {
  options: _react2.default.PropTypes.array,
  value: _react2.default.PropTypes.string
}, _class.defaultProps = {
  options: [],
  value: ''
}, _temp);
exports.default = SearchFieldTypeSelector;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchFieldTypeSelector/SearchFieldTypeSelector.jsx
// module id = 2701
// module chunks = 0